export default "__VITE_ASSET__ClsE4jJh__"